import { render } from "./TheNhomGiaiThiDauTheThaoVH.vue?vue&type=template&id=71425e59"
import script from "./TheNhomGiaiThiDauTheThaoVH.vue?vue&type=script&lang=js"
export * from "./TheNhomGiaiThiDauTheThaoVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__